<template>
  <Modal v-if="showPlanPopup" :active="showPlanPopup" :hideExit="true" @cancel="closeModal" @container="closeModal" mClass="p-0 border-radius">
    <div class="pt-3 pb-6 px-4 bg-light2 modal-plan__container">
      <div class="gp_modal-close p-1" @click="closeModal">
        <i class="icon icon-cancel"></i>
      </div>
      <div class="d-flex justify-content-center mb-3">
        <img class="modal-plan__img" :src="require('@/core/assets/new-dashboard/unlock-features.svg')" />
      </div>
      <h4 class="heading-h4-18-semi text-light-high mb-2">{{ $t("support.planModalTitle") }}</h4>
      <p class="paragraph-14-regular text-light-low mb-4">{{ $t("dashboard.step4Desc") }}</p>
      <div class="bg-primary-300 clickable border-radius py-1 d-flex justify-content-center" @click="redirectToPricing">
        <p class="body-14-medium txt-light-600">{{ $t("support.seePLan") }}</p>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from "vuex";
import dynamicTriggerContent from "@/mixins/dynamicTriggerContent";

export default {
  name: "PlanModal",
  mixins: [dynamicTriggerContent()],
  computed: {
    ...mapState("account", {
      showPlanPopup: "showPlanPopup"
    })
  },
  methods: {
    closeModal() {
      this.$store.commit("account/SHOW_PLAN_MODAL", false);
    },
    redirectToPricing() {
      this.closeModal();
      this.$router.push({
        name: "Pricing",
        query: {
          from: this.dynamicTrigger.seasonal_holiday_templates
        }
      });
    }
  }
};
</script>

<style lang="scss">
.modal-plan {
  &__container {
    width: 424px;
    position: relative;

    .icon-cancel {
      font-size: 16px;
    }
  }

  &__img {
    width: 113px;
  }
}
</style>
